module.exports = __webpack_public_path__ + "img/icon_voucher_content_corner.f848dbea.png";